import client from './main-client';

export const getListingLeadsNotesApi = (params) => client().get('/listing-leads-notes', { params });
export const updateListingLeadsNotesApi = (params) => client().patch(`/listing-leads-notes/${params.id}`, params);
export const addListingLeadsNotesApi = (data) => client().post('/listing-leads-notes', data);
export const deleteListingLeadsNotesApi = (params) => client().delete(`/listing-leads-notes/${params.id}`);
